import React from 'react';
import { Box, Paper, Typography, Button, Stack, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const CookieBanner = () => {
  const { consent, acceptCookies, declineCookies } = useCookieConsent();

  if (consent !== null) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        p: { xs: 1.5, sm: 2 },
      }}
    >
      <Paper
        elevation={8}
        sx={{
          maxWidth: 720,
          mx: 'auto',
          p: { xs: 2, sm: 3 },
          borderRadius: 3,
          background: 'rgba(255,255,255,0.97)',
          backdropFilter: 'blur(8px)',
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="subtitle1" fontWeight={600} gutterBottom>
          Sütibeállítások
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
           Weboldalunk analitikai sütiket használ (Google Analytics, Microsoft Clarity)
           a látogatottság elemzésére és a felhasználói élmény javítására. 
           Elutasítás esetén csak a működéshez szükséges sütik kerülnek használatra.{' '}
          <Link component={RouterLink} to="/sutik" underline="hover" color="primary">
            Részletek
          </Link>
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="flex-end">
          <Button
            variant="outlined"
            onClick={declineCookies}
            size="small"
            sx={{ borderRadius: 2 }}
          >
            Csak szükségesek
          </Button>
          <Button
            variant="contained"
            onClick={acceptCookies}
            size="small"
            sx={{ borderRadius: 2 }}
          >
            Elfogadom
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default CookieBanner;
